import { PolymerElement, html } from "@polymer/polymer";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconVideoBlack from "../../../../images/icons/icon_video_black.svg";
import iconExpBlack from "../../../../images/icons/icon_exp_black.svg";
import iconModuleBlack from "../../../../images/icons/icon_module_black.svg";
import iconTimeBlack from "../../../../images/icons/icon_time_black.svg";
import iconChecklistGreen from "../../../../images/icons/icon_checklist_green.svg";
import iconDetailWhite from "../../../../images/icons/icon_detail_white.svg";

import { _isShowSponsoreChannel, _sponsoreChannelLogo, _sponsoreChannelCategory, _sponsoreChannelName, _checkExpDate, _checkPoint, _checkPaidList, _checkStatusRegister, _checkPassedEcourse, _isVideoContent, _isArticleContent } from "../../../../utils/ecourse";

import "./EcourseListCard.style";

import Alodokter from "../../../../utils/Alodokter";
import General from "../../../../utils/General";
import EcourseAnalytics from "../../../../analytics/EcourseAnalytics";

class EcourseListCard extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-list-card-style"></style>
      <div id="ecourse-card" class="container" on-click="onClickCardEcourse">
        <template is="dom-if" if="{{_isShowSponsoreChannel(listEcourse)}}">
          <div class="container-channel">
            <img src="{{_sponsoreChannelLogo(listEcourse)}}" class="channel-logo" />
            <div>
              <p>{{_sponsoreChannelCategory(listEcourse)}}</p>
              <h4>{{_sponsoreChannelName(listEcourse)}}</h4>
            </div>
          </div>
        </template>
        <div class="container-content">
          <div class="content-row">
            <template is="dom-if" if="{{_isVideoContent(listEcourse.type)}}">
              <img src="{{iconVideoBlack}}" class="icon-content-black" />
            </template>
            <template is="dom-if" if="{{_isArticleContent(listEcourse.type)}}">
              <img src="{{iconModuleBlack}}" class="icon-content-black" />
            </template>
            <h2>{{listEcourse.title}}</h2>
          </div>
          <div class="container-field">
            <div class="content-field">{{listEcourse.field.name}}</div>
          </div>
          <div class="content-row">
            <div class="text-content">
              <img src="{{listEcourse.doctor_organization.logo}}" class="text-content-icon" />
              {{listEcourse.doctor_organization.name}} |
              <template is="dom-if" if="{{_checkExpDate(listEcourse.expired_date)}}">
                <img src="{{iconExpBlack}}" class="text-content-icon" style="margin-left: 8px;" />
                {{listEcourse.expired_date}} |
              </template>
              <img src="{{iconModuleBlack}}" class="text-content-icon" style="margin-left: 8px;" />
              {{listEcourse.total_module}} |
              <img src="{{iconTimeBlack}}" class="text-content-icon" style="margin-left: 8px;" />
              {{listEcourse.duration}}
            </div>
          </div>
          <div class="container-skp-price">
            <template is="dom-if" if="{{_checkPoint(listEcourse.skp_point)}}">
              <div class="text-skp">+{{formattedSkpPoint(listEcourse.skp_point)}} SKP</div>
            </template>
            <template is="dom-if" if="{{!_checkPoint(listEcourse.skp_point)}}">
              <div></div>
            </template>
            <template is="dom-if" if="{{_checkPaidList(listEcourse.is_paid, listEcourse.user_status)}}">
              <div class="content-text-price">Harga {{listEcourse.payment_info.normal_price}}</div>
            </template>
            <template is="dom-if" if="{{_checkStatusRegister(listEcourse.user_status)}}">
              <div class="content-text-registered"><img src="{{iconChecklistGreen}}" class="icon-checklist" /> Sudah Terdaftar</div>
            </template>
          </div>
          <template is="dom-if" if="{{_checkPassedEcourse(listEcourse.user_status)}}">
            <div class="container-ecourse-passed">Anda sudah lulus di E-Course ini</div>
          </template>
          <div class="container-button-detail">
            <div class="button-detail" on-click="onClickButtonDetailEcourse"><img src="{{iconDetailWhite}}" class="icon-button-detail" on-click="onClickButtonDetailEcourse" /> Lihat Detail</div>
          </div>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number,
      },
      userUid: {
        type: String,
      },
      listEcourse: {
        type: Object,
      },
      page: {
        type: Number,
      },
      isImpression: {
        type: Boolean,
        value: false,
      },
      iconVideoBlack: {
        type: String,
        value: iconVideoBlack,
      },
      iconExpBlack: {
        type: String,
        value: iconExpBlack,
      },
      iconModuleBlack: {
        type: String,
        value: iconModuleBlack,
      },
      iconTimeBlack: {
        type: String,
        value: iconTimeBlack,
      },
      iconChecklistGreen: {
        type: String,
        value: iconChecklistGreen,
      },
      iconDetailWhite: {
        type: String,
        value: iconDetailWhite,
      },
      _isShowSponsoreChannel: {
        type: Function,
        value: () => _isShowSponsoreChannel,
      },
      _sponsoreChannelLogo: {
        type: Function,
        value: () => _sponsoreChannelLogo,
      },
      _sponsoreChannelCategory: {
        type: Function,
        value: () => _sponsoreChannelCategory,
      },
      _sponsoreChannelName: {
        type: Function,
        value: () => _sponsoreChannelName,
      },
      _checkExpDate: {
        type: Function,
        value: () => _checkExpDate,
      },
      _checkPoint: {
        type: Function,
        value: () => _checkPoint,
      },
      _checkPaidList: {
        type: Function,
        value: () => _checkPaidList,
      },
      _checkStatusRegister: {
        type: Function,
        value: () => _checkStatusRegister,
      },
      _checkPassedEcourse: {
        type: Function,
        value: () => _checkPassedEcourse,
      },
      _isVideoContent: {
        type: Function,
        value: () => _isVideoContent,
      },
      _isArticleContent: {
        type: Function,
        value: () => _isArticleContent,
      },
      formattedSkpPoint: {
        type: Function,
        value: () => General.formattedSkpPoint,
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();

    const observerOptions = {
      rootMargin: "-120px 0px 0px 0px",
    };
    this._loadObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio !== 0 && !this.isImpression) {
        this.isImpression = true;
        this.dispatchEvent(new CustomEvent("tracking-impression-load", { detail: this.listEcourse }));
      }
    }, observerOptions);
    this._loadObserver.observe(this.shadowRoot.querySelector("#ecourse-card"));

    window.addEventListener(
      "load",
      function () {
        this._loadObserver.unobserve(this.shadowRoot.querySelector("#ecourse-card"));
        window.addEventListener(
          "scroll",
          function () {
            this._scrollObserver = new IntersectionObserver((entries) => {
              if (entries[0].intersectionRatio !== 0 && !this.isImpression) {
                this.isImpression = true;
                this.dispatchEvent(new CustomEvent("tracking-impression-scroll", { detail: this.listEcourse }));
              }
            }, observerOptions);
            this._scrollObserver.observe(this.shadowRoot.querySelector("#ecourse-card"));
          }.bind(this)
        );
      }.bind(this)
    );
  }

  onClickCardEcourse(e) {
    e.stopPropagation();
    this.onNavigationDetail(e, true);
  }

  onClickButtonDetailEcourse(e) {
    e.stopPropagation();
    this.onNavigationDetail(e, false);
  }

  onNavigationDetail(e, isFromCard) {
    const data = this.listEcourse;
    this.sendGaClickCardEcourse(data, isFromCard);
    this.sendGA4EcourseSelectItem(data, isFromCard);
    window.location = window.location.origin + `/ecourse/${data.slug}`;
  }

  sendGaClickCardEcourse(data, isFromCard) {
    let additionalTracker = this.getAdditonalTracker(data);
    const eventAction = isFromCard ? "e_course_card_clicked" : "ecourse_see_detail_button_clicked";
    const ecourseType = data.is_paid ? "paid" : "free";
    const eventLabel = `${additionalTracker}ecourse_title: ${data.title} | ecourse_category: ${data.category} | ecourse_type: ${ecourseType} | pagination_position: ${this.page} | device_category: desktop`;
    Alodokter.sendEventGA("e-course landing page", eventAction, eventLabel);
  }

  sendGA4EcourseSelectItem(data, isFromCard) {
    const dataToSend = {
      ecourse: data,
      is_from_card: isFromCard,
      is_registered: _checkStatusRegister(data.user_status),
    };
    EcourseAnalytics.selectItem(dataToSend);
  }

  getAdditonalTracker(data) {
    let additionalTracker = this.getTrackingUserUid();
    if (additionalTracker) {
      let userStatus = !data.user_status ? "not_enrolled" : "enrolled";
      additionalTracker = `${additionalTracker}ecourse_enrollment_status: ${userStatus} | `;
    }
    return additionalTracker;
  }

  getTrackingUserUid() {
    let userUid = "";
    if (this.userUid && this.isLogin) {
      userUid = `user_uid: ${this.userUid} | `;
    }
    return userUid;
  }
}

customElements.define("ecourse-list-card", EcourseListCard);
